export class ChatMessageReject {
    constructor(optionalOptions = {}) {
        this._rejects = document.querySelectorAll('[data-action="on-reject"]');
        if (!this._rejects) {
            this.destructor();
            return true;
        }

        let target

        this._rejects.forEach((reject) => {
            reject.addEventListener("click", () => {
                target = reject.dataset.target
                if (!document.querySelector(target).classList.contains('show')) {
                    document.querySelector(target).classList.add('show')
                }
            })
        })
    }

    destructor() {
        this._rejects = null;
    }
}

export default new ChatMessageReject();